import ReactGA from 'react-ga'

process.env.NODE_ENV === 'development'
  ? ReactGA.initialize('UA-158353899-3')
  : ReactGA.initialize('UA-158353899-2')

export const AnalyticEvent = (category: string, action: string, label?: string) => {
  ReactGA.event({
    category,
    action,
    label
  })
}
